// Sweep's routes inside the Companion.
//
// Everything lives under /advisor/sweep/* and is gated twice: customAuthGuard
// for sign-in, and the global feature guard in router/index.ts, which turns away
// anyone whose `features.sweep` is false.
//
// The printable request/order packages and the client's proposal page are
// deliberately outside that chrome. /p/:token in particular stays at the SPA
// root and unauthenticated: the backend builds client links as
// `${FRONTEND_URL}/p/<token>`, and the recipient is the customer, not a user.
import type { RouteRecordRaw } from 'vue-router'

const FEATURE = { feature: 'sweep' as const }

export const sweepRoutes: RouteRecordRaw[] = [
    { path: '/advisor/sweep', name: 'sweep-search', component: () => import('@/views/sweep/Search.vue'), meta: { ...FEATURE, title: 'Search – Sweep' } },
    { path: '/advisor/sweep/deals/:id', name: 'sweep-deal', component: () => import('@/views/sweep/Deal.vue'), meta: { ...FEATURE, title: 'Deals – Sweep' } },
    { path: '/advisor/sweep/accounts', name: 'sweep-accounts', component: () => import('@/views/sweep/Accounts.vue'), meta: { ...FEATURE, title: 'Accounts – Sweep' } },
    { path: '/advisor/sweep/accounts/:id', name: 'sweep-account', component: () => import('@/views/sweep/Account.vue'), meta: { ...FEATURE, title: 'Accounts – Sweep' } },
    { path: '/advisor/sweep/pipeline', name: 'sweep-pipeline', component: () => import('@/views/sweep/Pipeline.vue'), meta: { ...FEATURE, title: 'Pipeline – Sweep' } },
    { path: '/advisor/sweep/map', name: 'sweep-map', component: () => import('@/views/sweep/Map.vue'), meta: { ...FEATURE, title: 'Map – Sweep' } },
    { path: '/advisor/sweep/start', name: 'sweep-start', component: () => import('@/views/sweep/Start.vue'), meta: { ...FEATURE, title: 'How it works – Sweep' } },
    { path: '/advisor/sweep/settings', name: 'sweep-settings', component: () => import('@/views/sweep/Settings.vue'), meta: { ...FEATURE, title: 'Settings – Sweep' } },

    // Printable packages: no app chrome, so they print as a document.
    { path: '/advisor/sweep/requests/:id/package', name: 'sweep-request-package', component: () => import('@/views/sweep/RequestPackage.vue'), meta: { ...FEATURE, bare: true, title: 'Request package – Sweep' } },
    { path: '/advisor/sweep/orders/:id/package', name: 'sweep-order-package', component: () => import('@/views/sweep/OrderPackage.vue'), meta: { ...FEATURE, bare: true, title: 'Order package – Sweep' } },

    // Sweep's own in-app redirects, preserved.
    { path: '/advisor/sweep/lookup', redirect: to => ({ path: '/advisor/sweep', query: to.query }) },
    { path: '/advisor/sweep/inbox', redirect: '/advisor/sweep/pipeline' },
]

/** The client's proposal page: SPA root, public, no feature gate. */
export const sweepPublicRoutes: RouteRecordRaw[] = [
    { path: '/p/:token', name: 'sweep-proposal', component: () => import('@/views/sweep/Proposal.vue'), meta: { public: true, bare: true, title: 'Proposal' } },
]
